import ErrorView from "comps/ErrorView"
import { Component } from "react"

export type GeneralErrorBoundaryProps = {}

export default class GeneralErrorBoundary extends Component<
  GeneralErrorBoundaryProps
> {
  state = {
    hasError: false,
  }

  render() {
    if (this.state.hasError) {
      return <ErrorView statusCode={500} />
    } else {
      return this.props.children
    }
  }

  componentDidCatch(_error, _errorInfo) {
    this.setState({ hasError: true })
  }
}
